// Context
import { useLeadsContext } from "@/DataPages/context/crm/LeadsContext";

// Components
import SmartAddressFormSection from "@/Layouts/components/SmartAddressFormSection";

// Types

import { ICustomerAddress, TCustomerType } from "@/DataPages/context/crm/interfaces";

interface ICustomerAddressSectionProps {
	customerType: TCustomerType;
}

function CustomerAddressSection(props: Readonly<ICustomerAddressSectionProps>) {
	const { customerType } = props;

	/* Context */
	const { isSavingLead, onChangeContext, getContextError } = useLeadsContext();

	function onValidateAddressAction(address: Partial<ParsedAddress>) {
		const newAddress = {
			address1: address.address1,
			address2: address.address2,
			city: address.city,
			state: address.stateCode,
			zipCode: address.zipCode,
			country: address.countryCode,
		};
		onChangeContext<ICustomerAddress>("customer", "address", newAddress as ICustomerAddress);
	}

	return (
		<SmartAddressFormSection
			title="Address"
			disabled={isSavingLead}
			variant={customerType}
			requiredFields={getContextError("customer", "address")}
			onValidateAddressAction={onValidateAddressAction}
			onCallback={() =>
				onValidateAddressAction({ address1: "", address2: "", city: "", stateCode: "", zipCode: "", countryCode: "" })
			}
		/>
	);
}

export default CustomerAddressSection;
